import type { FetchPageServiceParameters } from "~/core/composables/useFetchPageV2";
import type { PaginatedList } from "~/core/models/PaginatedList.interface";
import RestService from "~/core/services/rest.service";
import {
  DEFAULT_QR_CODE_HEIGHT,
  DEFAULT_QR_CODE_WIDTH,
} from "~/modules/applicationManagement/constants/constants";
import type { MobileInterface } from "~/modules/applicationManagement/models/Mobile.interface";
import organizationService from "~/modules/organization/services/organization.service";

class MobileInterfaceService extends RestService {
  async findWithPagination({
    organizationCode,
    page,
    pageSize,
    searchParams,
    sort,
  }: FetchPageServiceParameters): Promise<PaginatedList<MobileInterface>> {
    const params = { page, pageSize, sort, filter: searchParams };

    return this.$apiV2.get(
      this.getOrganizationMobileAppInterfacesPath(organizationCode),
      { params },
    );
  }

  async generateQRCode(
    organizationCode: number,
    clientId: string,
    qrCodeWidth?: number,
    qrCodeHeight?: number,
  ) {
    const params = {
      qrCodeWidth: qrCodeWidth ?? DEFAULT_QR_CODE_WIDTH,
      qrCodeHeight: qrCodeHeight ?? DEFAULT_QR_CODE_HEIGHT,
    };
    return this.$apiV2.get(
      `${this.getOrganizationMobileAppInterfacePath(organizationCode, clientId)}/qrcode`,
      {
        params,
        headers: { Accept: "image/png" },
        responseType: "arraybuffer",
      },
    );
  }

  async downloadOfflineConfigurationZip(
    organizationCode: number,
    clientId: string,
    password: string,
  ) {
    return this.$apiV2.post(
      `${this.getOrganizationMobileAppInterfacePath(organizationCode, clientId)}/configuration/offline`,
      { password },
      {
        headers: { Accept: "application/octet-stream" },
        responseType: "arraybuffer",
        timeout: Infinity,
      },
    );
  }

  private getOrganizationMobileAppInterfacesPath(organizationCode?: number) {
    return `${organizationService.getOrganizationPath(organizationCode)}/interfaces/mobile`;
  }

  private getOrganizationMobileAppInterfacePath(
    organizationCode: number,
    clientId: string,
  ) {
    return `${this.getOrganizationMobileAppInterfacesPath(organizationCode)}/${clientId}`;
  }
}

export default new MobileInterfaceService();
